<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/ticketList/">Ticket</a></li>
      <li class="breadcrumb-item active" aria-current="page">View Ticket</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3 mb-4">
      <div class="col-6">
        <label class="mr-3" style="font-size:24px;font-weight: 600;margin-top: -6px;">Ticket#
          {{viewTicket.sourceTicketNum}}</label> <span class="v1"></span>
        <label class="ml-3 stus">{{viewTicket.status | replaceStatus}}</label>
      </div>
      <div class="col-6 text-right" *ngIf="user.role === 'ROLE_ADMIN'"></div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="inner-box">
          <label class="text-black"><b>Subject</b> : {{viewTicket.subject}}</label>
        </div>
        <div class="inner-box" style="min-height:343px;">
          <div class="row mt-3">
            <div class="col">
              <div class="">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                <textarea id="comments" [(ngModel)]="comments" [ngModelOptions]="{standalone: true}"
                          class="form-control" placeholder="Add comments..."
                          (blur)="blurComments()" [ngClass]="{'is-invalid':commentsError}" required>
                </textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 required">
                    <div class="form-group">
                      <input type="file" id="attachmentss" (change)="addAttachment($event)" placeholder="attachments"
                             class="form-control" style="border: none!important;" required>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <div class="" style="margin: 5px;" *ngFor="let ticket of commentsList">
                <div row="row mt-3">
                  <div class="col-md-4" style="display: flex;font-size: 16px;padding-left: 0px!important;">
                    <span><i class="fa fa-user-circle mr-2"></i></span>
                    <span> {{ticket?.commenterName}}</span>
                  </div>
                  <div class="col-md-4 text-right float-right" style="position: relative;top: -21px;font-size: 12px">
                    {{ticket?.modifiedDate}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4" style="margin-left: 10px; font-size: 13px;">
                    <label class="text-black">{{ticket.content}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col ml-2">
              <div class="">
                <div row="row mt-3">
                  <div class="col-md-4" style="display: flex;font-size:16px;padding-left: 0px;!important;">
                    <span> <i class="fa fa-user-circle mr-2"></i></span>
                    <span> {{viewTicket?.commenterName}}</span>
                  </div>
                  <div class="col-md-4 text-right float-right" style="position: relative;top: -21px;font-size: 12px">
                    {{viewTicket?.createdDate}}
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label class="text-black" style="margin-left: 10px; font-size:13px"
                           *ngFor="let a of details">{{a}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="inner-box" style="min-height:485px;">
          <div class="container my-4">
            <span><i class="fa fa-calendar mr-2" aria-hidden="true"></i>{{viewTicket?.createdDate}}</span>
            <div class="accordion md-accordion mt-4" id="accordionEx" role="tablist" aria-multiselectable="true">
              <div class="">
                <div class="" role="tab" id="headingOne1">
                  <h5 class="mb-0 title">
                    <a class="a tc" data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne1"
                       aria-expanded="true"
                       aria-controls="collapseOne1">
                      Support Details
                      <span class="icon"></span>
                    </a>
                  </h5>
                </div>
                <hr>
                <div id="collapseOne1" class="collapse show mb-3" role="tabpanel" aria-labelledby="headingOne1"
                     data-parent="#accordionEx">
                  <div class="">
                    <label class="text-black"><span
                      class="ml-1">{{viewTicket.commenterName}}</span></label><br>
                    <label class="text-black"><span
                      class="ml-1">{{viewTicket?.commenterEmail}}</span></label><br>
                  </div>
                </div>
              </div>
              <div class="" *ngIf="viewTicket.attachmentsSize != 0 && viewTicket.attachmentsSize != null">
                <div class="" role="tab" id="headingTwo2">
                  <h5 class="mb-0 title">
                    <a class="a collapsed tc" data-toggle="collapse" data-parent="#accordionEx" href="#collapseTwo2"
                       aria-expanded="false" aria-controls="collapseTwo2">
                      Attachments
                    </a>
                  </h5>
                </div>
                <hr>
                <div id="collapseTwo2" class="collapse" role="tabpanel" aria-labelledby="headingTwo2"
                     data-parent="#accordionEx">
                  <label *ngFor="let single of singleAttachment" style="margin-left: 35px;"><i
                    class="fa fa-file-pdf-o mr-2" style="color:#8f5cbe;font-weight: 600;"></i><a
                    (click)="getPdf(single)" target="_blank">{{single.name}}</a></label><br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br><br>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/ticketList" class="btn btn-cancel">Close</button>
      <button type="submit" (click)="newApi()" class="btn btn-orange ml-3">Save</button>
    </div>
  </div>
</div>
